import { render, staticRenderFns } from "./package-tab.vue?vue&type=template&id=71806197&scoped=true"
import script from "./package-tab.vue?vue&type=script&lang=js"
export * from "./package-tab.vue?vue&type=script&lang=js"
import style0 from "./package-tab.vue?vue&type=style&index=0&id=71806197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71806197",
  null
  
)

export default component.exports